<template>
  <h2>Contract User Management</h2>

  <div id="topContainer">

    <div id="creatNewContractUserButtonAndLabel">
      <label class="subHeaderFont" id="newconU" for="createNewContractUserButton">Create New Contract User: </label>

      <div class="material-icons-outlined forCreateRecordIcon" data-tooltip="tooltip" title="Create"
        @click="this.$refs.createNewContractUserModal.ShowModal();" @keydown.enter="this.$refs.createNewContractUserModal.ShowModal();" aria-labelledby="newconU"> add_card </div>
    </div>

    <div class="radioContainer" id="radioContainerActiveButtons">
      <!-- {{showAllActiveOrInactive}} -->
        <div class="form-check">
            <label class="form-check-label" id="activeId" for="flexRadioDefault1" @click="this.$refs.activeRadio.click();">
                <input class="form-check-input" type="radio" :value="false" v-model="showAllActiveOrInactive"
                       @change="ShowAllActiveClicked('active')" ref="activeRadio" aria-labelledby="activeId">

                Active
            </label>
        </div>

        <div class="form-check">
            <label class="form-check-label" id="allId" for="flexRadioDefault1" @click="this.$refs.allRadio.click();">
                <input class="form-check-input" type="radio" :value="true" v-model="showAllActiveOrInactive"
                       @change="ShowAllActiveClicked('all')" ref="allRadio" aria-labelledby="allId">

                All
            </label>
        </div>

    </div>


  </div>


  <!-- <button class="btn btn-primary excelButton" @click="ExportExcel"> 
      <div class="material-icons" data-tooltip="tooltip" title="Edit Record"  @click="this.ShowEditModal(actionColumnEditSlot)"> exit_to_app </div> Export to Excel
    </button> -->

  <ModalBootstrap ModalId="createNewContractUserModal" ModalTitle="Create a New Contract User" ButtonText=""
    ref="createNewContractUserModal" aria-label="Create New Contract User">

    <template v-slot:body>
      <UserContractsForm :loaded-user-contract="{ contractId: '-1', userProfileId: '-1' }"
        @user-contract-form-submitted="AddEditFormSubmitted" ref="userContractNewForm"></UserContractsForm>
    </template>

    <template v-slot:footer>

      <button type="button" class="btn btn-secondary"
        @click="this.$refs.createNewContractUserModal.HideModal();">Cancel</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal"
        @click="this.$refs.userContractNewForm.Submit()">Save</button>

    </template>
  </ModalBootstrap>

  <ModalBootstrap ModalId="editContractUserModal" ModalTitle="Edit Contract User" ButtonText=""
    ref="editContractUserModal" @modal-close-event="EditModalClosed" aria-label="Edit Contract User">
    <template v-slot:body>
      <UserContractsForm :loaded-user-contract="this.userContractEditing"
        @user-contract-form-submitted="AddEditFormSubmitted" ref="userContractEditForm"></UserContractsForm>
    </template>

    <template v-slot:footer>

      <button type="button" class="btn btn-secondary"
        @click="this.$refs.editContractUserModal.HideModal();">Cancel</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal"
        @click="this.$refs.userContractEditForm.Submit()">Save Changes</button>

    </template>
  </ModalBootstrap>

  <DataTableComponent v-if="this.getAllUserContractsUrl" :data-url="this.getAllUserContractsUrl"
    :column-list-d-b="this.userContractColumnNames" :column-list-pretty="this.userContractColumnNamesPretty"
    column-name-id="contractUserProfileId" ref="contractUserDatatable" :show-search="true"
    plural-data-name="Contract Users" :center-column-indexes="[1, 3]">

    <template v-slot:extraColumnHeaders>
      <th class="nosearch">Active</th>
    </template>

    <template #extraColumns="extraColumnRowData">
      <td :data-sort="extraColumnRowData.isActive">
        <div class="form-check activeCheckBoxContainer">
          <input class="form-check-input" type="checkbox" value="" aria-label="Check this box to make the record active"
            :id="'flexCheckDefault_' + extraColumnRowData.contractUserProfileId"
            @change="ActiveCheckboxHit(extraColumnRowData)" v-model="extraColumnRowData.isActive">
        </div>
      </td>
    </template>

    <template #actionColumnEditSlot="actionColumnEditSlot">

      <td class="actionColumn tdclass">

        <div class="material-icons forIconEdit text-success" data-tooltip="tooltip" title="Edit Record"
          @click="this.ShowEditModal(actionColumnEditSlot)"> edit </div>

      </td>

    </template>

  </DataTableComponent>
</template> 
  
<script>

import { store } from "@/store/store.js";
import $ from "jquery";
import DataTableComponent from "@/components/dataSupport/DataTable.vue";
import ModalBootstrap from "@/components/dataSupport/ModalBootstrap.vue"
import UserContractsForm from "./UserContractsForm.vue";
//import exportFromJSON from 'export-from-json';

export default {
  name: "UserContractsTable",
  components: {
    DataTableComponent, ModalBootstrap, UserContractsForm
  },
  mounted() {
    this.getAllUserContractsUrl = store.webAPIUrl + "ContractUserProfiles/GetAllByActiveDTO/" + this.showAllActiveOrInactive;
  },
  data() {
    return {
      getAllUserContractsUrl: "",
      userContractColumnNames: ['contractNumber', 'rankAcronym', 'contractUserFullName', 'contractUserRoleAcronym', 'contractUserEmail'],
      userContractColumnNamesPretty: ['Contract Number', 'Rank', 'User', 'Role', 'Email'],
      userContractEditing: {},
      showAllActiveOrInactive: false
    };
  },
  methods: {
    ShowEditModal(_contractUser) {
      //console.log("Opening contract modal | data: ", _contractUser);
      this.userContractEditing = _contractUser;
      this.$refs.editContractUserModal.ShowModal();
      Object.assign(this.$refs.userContractEditForm.editedUserContract, _contractUser);
    },
    EditModalClosed() {
      //console.log("edit modal closed");
      this.userContractEditing = {};
    },
    AddEditFormSubmitted() {
      if (this.$refs.editContractUserModal.myModal != null)
        this.$refs.editContractUserModal.HideModal();
      if (this.$refs.createNewContractUserModal.myModal != null)
        this.$refs.createNewContractUserModal.HideModal();
      this.$refs.contractUserDatatable.LoadDataAndInitializeTable(store.webAPIUrl + "ContractUserProfiles/GetAllByActiveDTO/false");
      this.showAllActiveOrInactive = false;
    },
    ActiveCheckboxHit(editRow) {

      //get dataTable row by Id:
      var DataRowToEdit = this.$refs.contractUserDatatable.loadedData.find(x => x.contractUserProfileId == editRow.contractUserProfileId);
      //update data in table:
      DataRowToEdit.isActive = editRow.isActive;
      DataRowToEdit.activeStatus = editRow.isActive ? "Active" : "Inactive";
      //update data in DB:
      var actionUrl = store.webAPIUrl + "ContractUserProfiles/" + editRow.contractUserProfileId;

      //set update date to now
      editRow.updateDate = new Date();

      $.ajax({
        method: "PUT",
        data: JSON.stringify(editRow),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        url: actionUrl,
        success: (result) => {

          this.successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
        },
      });

    },
    ShowAllActiveClicked(tableType) {
      if (tableType == "all") {
        console.log("get all");
        this.$refs.contractUserDatatable.LoadDataAndInitializeTable(store.webAPIUrl + "ContractUserProfiles/GetDTO");
      }
      else {
        this.$refs.contractUserDatatable.LoadDataAndInitializeTable(store.webAPIUrl + "ContractUserProfiles/GetAllByActiveDTO/false");
      }
    },
    //ExportExcel(){

    //  const data = this.$refs.contractUserDatatable.loadedData;
    //  const fileName = 'ContractUserDetails'
    //  const exportType = 'csv'

    //   exportFromJSON({ data, fileName, exportType });
    // }

  },
  unmounted() {

    //console.log("force update user contracts table"); 
    this.$forceUpdate();
  }
}
</script>
  
<style scoped>
.dtContainer {
  display: flex;
  flex-direction: column;
  margin: 15px;
  padding-right: 5px;
  padding-bottom: 15px;
  margin-bottom: 30px;
  width: 88%;
}

.forIconEdit {
  cursor: pointer;
  color: #0f63a8 !important;
}

p {
  text-align: left;
}

.activeCheckBoxContainer {
  padding-bottom: 1.25rem;
}

.radioContainer {
  margin-bottom: 1rem;
}

.excelButton {
  width: 175px;
}

#topContainer {
  display: flex;
}

#creatNewContractUserButtonAndLabel {
  width: 270px;
  display: flex;
  justify-content: space-between;
}

#radioContainerActiveButtons {
  width: 185px;
  display: flex;
  justify-content: space-evenly;
}</style>
